import React from 'react';
// ##### 25-05-19 Komarov
import { useSelector } from 'react-redux';

// ##### Komarov 2025-07-14
const SaveReference = ({ customer_reference }) => {
  // ##### Komarov 2025-08-05
  const CustomerReference = useSelector(state => state.pagesRedux[state.language]?.CustomerReference || '');

  return (
    <div data-component="SaveReference">
      {/* <div>Hi there!</div> */}
      {/* ##### 23-10-05 Komarov: TODO: брать перевод из Смарта */}
      <div>
        {CustomerReference}{' '}
        <span
          style={{
            fontSize: '17px',
            fontFamily: 'Arial Narrow',
            color: '#4D4B4B',
            fontWeight: 'bold',
          }}
        >
          {customer_reference}{' '}
        </span>
      </div>
    </div>
  );
};

// ##### 25-05-02 Komarov
export default SaveReference;
